<section id="content">
    <div class="page page-profile">
  
      <!-- page header -->
      <div class="pageheader">
        <h2>Language Details</h2>
        <div class="page-bar">
          <ul class="page-breadcrumb">
            <li>
              <a [routerLink]="'/super/'+AppFrontRoutes.SDASHBOARD"><i class="fa fa-home"></i>
                {{AppSettings.SITE_TITLE | titlecase}}</a>
            </li>
            <li>
              <a [routerLink]="'/super/'+AppFrontRoutes.SUPER_LANG">Language List</a>
            </li>
          </ul>
        </div>
      </div>
  
      <!-- page content -->
      <div class="pagecontent">
  
        <!-- row -->
        <div class="row">
          <div class="col-md-12">
            <div class="tile tile-simple">
  
              <!-- tile body -->
              <div class="tile-body">
                <div role="tabpanel">
  
              
                  <div class="tab-content">
  
                    <div role="tabpanel" class="tab-pane active">
  
                      <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                        <table datatable data-paging='false' [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                          id="table1" *ngIf="langdata">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Label Value (English)</th>
                              <th>Label Value (Italian)</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let record of langdata; let i = index" id="{{record.id}}">
                              <td>{{i + 1}}</td>
                              <td>
                                  <input class="form-group" type="text" value="{{ langdata[i].english }}" [(ngModel)]="langdata[i].english">
                              </td>
                              <td>
                                <input class="form-group" type="text" value="{{ langdata[i].italian }}" [(ngModel)]="langdata[i].italian">    
                              </td>
                              <td>
                                <div class="btn-group dropup">
                                  <button style="background: #57b257;color: white;" (click)="save_lang(langdata[i].id,langdata[i].english,langdata[i].italian)" type="button" class="btn"> Update</button>
                                </div>
                              </td>
                            </tr>
  
                            
                          </tbody>
  
                        </table>
                      </div>
                    </div>
  
                
  
                  </div>
  
                </div>
  
  
              </div>
  
            </div>
          </div>
        </div>
  
      </div>
    </div>
  </section>
  
  
  <div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">
  
    <div class="modal-dialog">
      <div class="modal-content">
  
        <div class="modal-header">
          <h3 class="modal-title custom-font">EXPORT TABLE</h3>
        </div>
  
        <div class="modal-body column_export">
          <div class="row flexs">
            <div id="datatableExportBtn1" class="export_dynamic_btn">
            </div>
            <button class="btn btn-warning" data-dismiss="modal">Close</button>
  
          </div>
  
        </div>
      </div>
    </div>
  </div>
  
  